import Image from 'next/image'

export default function SimpleImage(props) {
  const { alt, ...otherProps } = props;
  return (
    <Image loader={simpleLoader} unoptimized alt={alt} {...otherProps} />
  )
}

function simpleLoader({ src }) {
  return src;
}
